<fs-map *ngIf="location?.geometry?.coordinates" (mapInit)="onMapInit($event)">
  <sn-icon class="fullscreen-btn fa fa-expand" size="lg" (click)="openMaximizedMap()"></sn-icon>
</fs-map>

<ng-container *ngIf="!location?.geometry?.coordinates">
  <div class="appliance-map-container">
    <button mat-button color="accent" type="button" (click)="onEditAppliance()">
      ADD LOCATION
    </button>
  </div>
</ng-container>
